// extracted by mini-css-extract-plugin
export var currencyInput = "_ju-1";
export var currencySymbol = "_ju-0";